import { createReducer, on } from '@ngrx/store';
import moment from 'moment';

import {
  GeneralSaveTriggerActions,
  SetIsError500Encountered,
  SetIsLanguageChangeTriggered,
  SetLicenseActions,
} from 'src/app/libs/store/actions/general.actions';
import { GeneralState } from 'src/app/libs/store/states/general.states';

const initialState: GeneralState = {
  isError500Encountered: false,
  isLanguageChangeTriggered: false,
  saveStatus: null,
  license: null,
};

export const generalReducer = createReducer(
  initialState,
  on(SetIsError500Encountered, (state: GeneralState, props: any) => {
    return {
      ...state,
      isError500Encountered: props.isError500Encountered,
    };
  }),
  on(SetIsLanguageChangeTriggered, (state: GeneralState, props: any) => {
    return {
      ...state,
      isLanguageChangeTriggered: props.isLanguageChangeTriggered,
    };
  }),
  on(GeneralSaveTriggerActions, (state: GeneralState, props: any) => {
    return {
      ...state,
      saveStatus: { saveStatus: props.saveStatus, url: props.url, location: props.location },
    };
  }),
  on(SetLicenseActions, (state: GeneralState, props: any) => {
    return {
      ...state,
      license: {
        ...props,
        createdAt: moment(props.createdAt).format('DD MMMM YYYY'),
        expiredAt: moment(props.expiredAt).format('DD MMMM YYYY'),
      },
    };
  })
);
